import React from 'react'
import Head from 'next/head'
import { NextPage } from 'next'

import styles from './404.module.scss'

/* https://github.com/Chewy-Inc/storefront/tree/develop/src/main/webapp/WEB-INF/views/Errors */
const Custom404Page: NextPage = () => {
  return (
    <>
      <Head>
        <title>Chewy.com Page Not Found</title>
        <meta httpEquiv="Content-Type" content="text/html; charset=utf-8" />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <meta name="robots" content="noindex,nofollow" />
      </Head>
      <body className={styles.httpError}>
        <div className={styles.header}>
          <div className={styles.headerContainer}>
            <a href="/" title="Home">
              <img
                src="/assets/img/logo/chewy-may2019-site-logo-white.svg"
                className={styles.chewyLogo}
                alt="Chewy Homepage"
              />
            </a>
          </div>
        </div>
        <article className={styles.container}>
          <img
            className={styles.randomImg}
            src="https://cms-www.chewy.com/images/error-404/collage-1.jpg"
            id="random-image"
            alt="collage of different pets"
            data-src="https://www.chewy.com/assets/img/error-404/collage-1.jpg"
          />
          <section className={styles.errorInformation}>
            <h1 className={styles.statusCode}>404</h1>
            <p>
              Oops! Something&apos;s not right. The Chewy pack is on the case!
            </p>

            <a href="/" className={styles.cwBtn + ' ' + styles.cwBtn__action}>
              Visit our homepage
            </a>
          </section>
        </article>
      </body>
    </>
  )
}

export default Custom404Page